import { type Event } from '@/types/event';
import { formatDate, formatTimeRange } from '@/utils/date';
import { clsx } from 'clsx';
import styles from './EventDetails.module.css';

interface EventDetailsProps {
  event: Event;
  isOpen: boolean;
  onShare?: (e: React.MouseEvent) => void;
  hasCopied?: boolean;
}

/**
 * Expandable event details component
 * Uses CSS Grid for smooth height animation
 */
export function EventDetails({ event, isOpen, onShare, hasCopied }: EventDetailsProps) {
  return (
    <div className={clsx(styles.detailsWrapper, isOpen && styles.open)}>
      <div className={styles.detailsInner}>
        <img
          src={event.imageUrl}
          alt={event.name}
          className={styles.image}
        />

        <div className={styles.meta}>
          <p className={styles.datetime}>
            {formatDate(event.start)}
          </p>
          <p className={styles.venue}>{event.venue.name}</p>
          <p className={styles.datetime}>
            {formatTimeRange(event.start, event.end)}
          </p>
        </div>

        <p className={styles.description}>{event.description}</p>

        <a
          href={event.url}
          target="_blank"
          rel="noopener noreferrer"
          className={styles.ctaButton}
          onClick={(e) => e.stopPropagation()}
        >
          TICKETS
        </a>
        {onShare && (
          <button
            className={clsx(styles.shareButton, hasCopied && styles.copied)}
            onClick={onShare}
            disabled={hasCopied}
          >
            {hasCopied ? 'COPIED' : 'SHARE'}
          </button>
        )}
      </div>
    </div>
  );
}
